import React, { useEffect } from 'react';
import Switcher from '../../switcher';
import { autoBetCountList, autoBetDataKeys, globalTranslationKeys } from '../../../../enums';
import { useClickOutside } from '../../../../hooks';

const AutoBet = ({
  t,
  isStart,
  doBetSender,
  autoBetData,
  isBetAccepted,
  isDisabledBetSection,
  handleChangeAutoBet,
  updateIsDisabledBetSection,
}) => {
  const [ref, hasOutsideClick] = useClickOutside();
  const { isAutoBet, isOpened, autoBetCount } = autoBetData;

  const handleOpenAutoBetCountList = () => {
    if (isAutoBet) {
      handleChangeAutoBet(autoBetDataKeys.isAutoBet, false);
      handleChangeAutoBet(autoBetDataKeys.autoBetCount, 0);
      updateIsDisabledBetSection(false);
    } else {
      handleChangeAutoBet(autoBetDataKeys.isOpened, true);
    }
  };

  const handleClickAutoBetCount = (item) => {
    handleChangeAutoBet(autoBetDataKeys.autoBetCount, Number(item));
    handleChangeAutoBet(autoBetDataKeys.isAutoBet, true);
    handleChangeAutoBet(autoBetDataKeys.isOpened, false);
    if (isStart) {
      isStart && !isBetAccepted && doBetSender();
    } else {
      !isBetAccepted && updateIsDisabledBetSection(true);
    }
  };

  const autoBetCountContent = () => {
    return <>{isAutoBet && autoBetCount ? autoBetCount || '' : <></>}</>;
  };

  useEffect(() => {
    if (hasOutsideClick) {
      handleChangeAutoBet(autoBetDataKeys.isOpened, false);
      handleChangeAutoBet(autoBetDataKeys.isAutoBet, false);
      handleChangeAutoBet(autoBetDataKeys.autoBetCount, 0);
    }
  }, [hasOutsideClick]);

  return (
    <div
      className={`checkbox-wrp-item ${!isAutoBet && isDisabledBetSection ? 'passive' : ''}`}
      {...(isOpened ? { ref: ref } : {})}
    >
      <div className='checkbox-wrp-item-inner'>
        {isOpened ? (
          autoBetCountList.map((item) => {
            return (
              <button
                type='button'
                className='autobet-list-button'
                onClick={() => handleClickAutoBetCount(item)}
                key={item}
                title={item || ''}
              >
                <span>{item || null}</span>
              </button>
            );
          })
        ) : (
          <>
            <p className='auto-bet-txt' title={t(globalTranslationKeys.AutoBet)}>
              {t(globalTranslationKeys.AutoBet)}
            </p>
            {isAutoBet && autoBetCount ? (
              <button type='button' className='autobet-list-button'>
                <span>{autoBetCountContent()}</span>
              </button>
            ) : (
              autoBetCountContent()
            )}
            <Switcher
              isActive={isAutoBet}
              onClick={handleOpenAutoBetCountList}
              title={t(globalTranslationKeys.AutoBet)}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default AutoBet;
